import React from 'react';
import './chartcard.less';
import { getTotal, getAvg } from '../../utils/dataManager';

const ChartCard = ({ header, loading, error, children, values, height, description, hideAvg = false, hideTotal = false, headerRight = null, collapsed = false }) => {
  return (
    <div className={`chart-card${collapsed ? ' chart-card-collapsed' : ''}`}>
      <div className="chart-card-header">
        <span className="chart-card-title">{header}</span>
        <div className="chart-card-header-right">
          {headerRight}
          <div className="chart-card-stats">
            {!hideAvg && values && values.length > 0 && (
              <span>avg: <b>{getAvg(values)}</b></span>
            )}
            {!hideTotal && values && values.length > 0 && (
              <span>total: <b>{getTotal(values)}</b></span>
            )}
          </div>
        </div>
      </div>
      {!collapsed && description && <div className="chart-card-description">{description}</div>}
      {!collapsed && (
        <div className="chart-card-body" style={height ? { height } : {}}>
          {loading ? (
            <div className="spinner" />
          ) : error ? (
            <div className="alert alert-error">{error}</div>
          ) : (
            children
          )}
          <span className="chart-resize-anchor">{'\u00A0'}</span>
        </div>
      )}
    </div>
  );
};

export default ChartCard;
